import { QueryParams } from "@/api";

export interface TeacherSearchParams extends QueryParams {
  offset: number;
  limit: number;
  orderBy: string;
}

export const teacherSearchParamsMocks: TeacherSearchParams = {
  offset: 0,
  limit: 12,
  orderBy: "-id",
};

export const teacherSearchResponseMock = {
  count: 1,
  next: "https://localhost/api/v3/school/2000287688/teacher/?limit=5&offset=10&ordering=-email",
  previous:
    "https://localhost/api/v3/school/2000287688/teacher/?limit=5&ordering=-email",
  results: [
    {
      user: "496c3faf39774037bd7dae7f28c816b4",
      user_url:
        "https://localhost/api/v3/user/496c3faf39774037bd7dae7f28c816b4/",
      preferred_school: "d5bff6fbd6684677bb4a829b621fb89b",
      schools: [
        "d5bff6fbd6684677bb4a829b621fb89b",
        "3ffa7e5571704362a4716a7d385e5603",
      ],
      classrooms: [
        "eb6130bf0d10413583c44a3a7a6868bf",
        "28396bbf67cd41988e5f5884f5ef0428",
      ],
      subjects: ["Teaching"],
      role: "teacher",
      secondary_role: null,
      technology: null,
      lowest_preferred_grade_level: 2,
      highest_preferred_grade_level: 12,
      external_id: null,
    },
  ],
};
